import React, { Component } from 'react';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import Loader from 'react-loader-spinner';
import { DialogComponent } from '@syncfusion/ej2-react-popups';


export default class TrainingData extends Component {
    constructor() {
        super();

        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: true,
            });
        };

        this.settings = { effect: 'Zoom', duration: 600, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.deleteDocumentApi(this.state.editedId)
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: true });
            }
        }];

        this.state = {
            editDoc: false,
            uploadFile: false,
            addTextArea: false,
            editorState: "",
            planDocCharacterCount: 0,
            docCharacterCount: 0,
            showLoader: true,
            editedId: -1,
            languageList: [],
            projectPlanName: '',
            language: '',
            hideDeletePopup: true,
            showEditAction: false,
            autoTranslateChecked: false,
            hoverId: -1,
            documentCount: 10,
            isDocLimitExceeded: false,
            textFile: null,
            textFileType: null
        }
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.editDocument = this.editDocument.bind(this);
        this.editImageSrc = "./assets/images/edit2.png";
        this.documentList = [];
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchLanguageForTrainingDataApi();
            this.fetchDocumentListApi();
        }, 3000);
        var thisComponent = this;
        document.addEventListener("projectChanged", function (event) {
            thisComponent.state.showLoader = true;
            thisComponent.state.languageList = [];
            thisComponent.documentList = [];
            thisComponent.state.addTextArea = false;
            thisComponent.state.language = '';
            thisComponent.state.docCharacterCount = 0;
            thisComponent.projectId = event.projectId;
            thisComponent.fetchLanguageForTrainingDataApi(event.projectId);
            thisComponent.fetchDocumentListApi(event.projectId);
        });
    }

    fetchLanguageForTrainingDataApi(projectId) {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
              projectId = localStorage.getItem('currentProjectId');
            }
          }
        var thisComponent = this;
        $.ajax(
            {
                // url: "/api/agent-languages-asr",
                url: "/api/project-languages-selected",
                async: false,
                method: 'GET',
                data: {
                    projectId: projectId,
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
                success: function (res) {
                    thisComponent.state.showLoader = false;
                    if (res.success === true) {
                        thisComponent.state.languageList = res.result;
                        thisComponent.state.language = res.result[0].code
                        thisComponent.setState(thisComponent.state);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            }
        )
    }


    fetchDocumentListApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
              projectId = localStorage.getItem('currentProjectId');
            }
          }
        var thisComponent = this;
        $.ajax({
            url: "/api/asr-document",
            async: false,
            method: 'GET',
            data: {
                "projectId":projectId,
                "language": thisComponent.state.language
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                thisComponent.state.uploadFile = false;
                thisComponent.state.editDoc = false;
                thisComponent.state.showLoader = false;
                thisComponent.state.textFile = null;
                if (res.success === true) {
                    var documentList = res.result;
                    thisComponent.documentList = res.result;
                    if (res.result.length < thisComponent.state.documentCount) {
                        thisComponent.state.isDocLimitExceeded = true;
                    } else {
                        thisComponent.state.isDocLimitExceeded = false;
                    }
                    thisComponent.setState(thisComponent.state);
                }
            },
            error: function (xhr, error) {
                console.error("Error while loading training data :" + error)
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyFailToLoadData(response) {
        if (/null/i.test(response)) {
            this.notifyGeneralErrorMessage();
        } else {
            toast.dismiss();
            toast(<b style={{ color: "red" }}>{response}</b>, {
                position: "top-center",
                color: "red"

            });
        }
    }

    notifyGeneralErrorMessage = () => {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }

    onEditorStateChange = (e) => {
        const contentState = e.target.value;
        const oldContent = this.state.editorState;
        if (contentState.length > 2000) {
            this.state.editorState = oldContent;
            this.state.docCharacterCount = oldContent.length;
            this.state.textFile = oldContent;
        } else {
            this.state.docCharacterCount = contentState.length;
            this.state.editorState = e.target.value;
            this.state.textFile = e.target.value;
        }
        this.setState(this.state);
    }

    notifyWarning = (message) => {
        toast.dismiss();
        toast(<b><img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }

    saveDocumentApi = () => {
        var trainingDataComponent = this;
        if (trainingDataComponent.state.textFile == null ||
            trainingDataComponent.state.textFile == "") {
            trainingDataComponent.notifyWarning("Please choose a file");
        } else {
            var formData = new FormData();
            formData.append("projectIdString", localStorage.getItem("currentProjectId"));
            formData.append("content", trainingDataComponent.state.textFile);
            formData.append("language", trainingDataComponent.state.language);
            $.ajax({
                url: "/api/asr-document",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
                data: formData,
                contentType: false,
                processData: false,
                success: function (res) {
                    if (res.success === true) {
                        trainingDataComponent.state.editorState = EditorState.createEmpty();
                        trainingDataComponent.state.addTextArea = false;
                        trainingDataComponent.state.docCharacterCount = 0;
                        trainingDataComponent.fetchDocumentListApi();
                        trainingDataComponent.setState(trainingDataComponent.state);
                        trainingDataComponent.notifySuccess("ASR Training data added successfully")
                    } else {
                        trainingDataComponent.notifyFailToLoadData(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    notifySuccess(message) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }


    updateDocumentApi = () => {
        var thisComponent = this;
        thisComponent.state.textFile = thisComponent.state.editorState
        if (thisComponent.state.textFile == null ||
            thisComponent.state.textFile == "") {
            thisComponent.notifyWarning("Please enter content");
        } else {
            let data = {
                id: thisComponent.state.editedId,
                projectId: localStorage.getItem("currentProjectId"),
                content: thisComponent.state.textFile,
                language: thisComponent.state.language
            }
            $.ajax({
                url: "/api/asr-document",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        thisComponent.state.editorState = EditorState.createEmpty();
                        thisComponent.state.addTextArea = false;
                        thisComponent.state.editedId = -1;
                        thisComponent.state.docCharacterCount = 0;
                        thisComponent.fetchDocumentListApi();
                        thisComponent.setState(thisComponent.state);
                        thisComponent.notifySuccess("ASR Training data updated successfully")
                    } else {
                        thisComponent.notifyGeneralErrorMessage();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    editDocument = (e) => {
        var id = e.target.id.split("+")[0];
        this.state.editedId = id;
        this.state.addTextArea = true;
        var docTextArea = document.getElementById(id).innerHTML;
        this.state.editorState = docTextArea;
        this.state.docCharacterCount = 0;
        this.state.editDoc = true;
        this.state.uploadFile = false;
        this.setState(this.state)
    }

    handleChangeLang = (e) => {
        this.state.language = e.target.value
        this.state.addTextArea = false;
        this.state.docCharacterCount = 0;
        this.state.showLoader = true;
        this.setState(this.state);
        this.fetchDocumentListApi();
    }

    refreshData = () => {
        var trainingDataComponent = this;
        trainingDataComponent.documentList = [];
        trainingDataComponent.state.addTextArea = false;
        trainingDataComponent.state.docCharacterCount = 0;
        trainingDataComponent.fetchDocumentListApi()
    }

    deleteDocumentApi = (id) => {
        let trainingDataComponent = this;
        $.ajax({
            url: "/api/asr-document/" + id,
            async: false,
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    trainingDataComponent.state.addTextArea = false;
                    trainingDataComponent.setState({ hideDeletePopup: true });
                    trainingDataComponent.fetchDocumentListApi();
                    trainingDataComponent.notifySuccess("ASR Training data deleted successfully")
                } else {
                    trainingDataComponent.notifyFailToLoadData(res.result);
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    handleMouseEnterDoc = (e) => {
        var id = e.target.id;
        if (e.target.name == 'image') {
            id = e.target.id.split("+")[0];
        }
        this.state.hoverId = id;
        var element = document.getElementById(id);
        element.style.background = "#F0F0F0";
        var imgElement = document.getElementById(id + "+img");
        imgElement.style.display = 'block';
        this.setState(this.state);
    }

    handleMouseLeaveDoc = (e) => {
        this.state.hoverId = -1;
        var element = document.getElementById(e.target.id);
        element.style.background = "#ffffff";
        var imgElement = document.getElementById(e.target.id + "+img");
        imgElement.style.display = 'none';
        this.setState(this.state);
    }

    handleChangeFile = (event) => {
        if (event.target.files[0] != undefined && event.target.files[0] != null) {
            if (event.target.files[0].type == "text/plain" ||
                event.target.files[0].type == "") {
                var trainingDataComponent = this;
                var reader = new FileReader();
                let fileSize = (event.target.files[0].size) / 1000;
                if (fileSize < 2048) {
                    reader.onloadend = () => {
                        trainingDataComponent.state.textFile = reader.result;
                    }
                    trainingDataComponent.setState(trainingDataComponent.state);
                    reader.readAsText(event.target.files[0]);
                    trainingDataComponent.state.textFileType = event.target.files[0].type;
                    trainingDataComponent.setState(trainingDataComponent.state);
                } else {
                    document.getElementById("inputFile").value = ""
                    this.notifyWarning("Selected file size is large");
                }
            } else {
                document.getElementById("inputFile").value = "";
                this.notifyWarning("Selected file format is not supported");
            }
        }
    }

    addDocument = () => {
        if (document.getElementById("inputFile") != null) {
            document.getElementById("inputFile").value = "";
        }
        if (this.state.isDocLimitExceeded) {
            this.setState({
                addTextArea: true,
                editedId: -1,
                docCharacterCount: 0,
                autoTranslateChecked: false,
                uploadFile: true
            })
        } else {
            this.notifyWarning("Document limit exceeded for the current project");
        }
    }


    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.showLoader}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }} />


                <div style={{ display: !this.state.showLoader ? 'block' : 'none' }}>

                    <link rel="stylesheet" href="assets/css/toggleButton.css" />
                    {/* for toaster */}
                    <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

                    {/* for dialog component */}
                    <link href="./assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="./assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />

                    <ToastContainer className="Toast-at-center" />

                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-5">
                                    <h1 className="m-0 page-title">ASR Training Data</h1>
                                    {/* <h6 className="taglineTxt">Make agents learn from passages</h6> */}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">

                                    <div className="card-body p-0 mb-25">
                                        <div className="tab-content col-12 p-0">
                                            <div className="tab-pane active show" id="tab_1">
                                                <div className="card card-primary mt-3">
                                                    <div className="card-body raise-form" style={{ minHeight: '450px' }}>

                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <h6 className="nav-item" style={{
                                                                    color: '#282a65',
                                                                    marginTop: '10px'
                                                                }}>Provide plain text files for vocabulary training
                                                                </h6>
                                                            </div>
                                                            <div className="col-sm-4" style={{ marginTop: '1.3rem' }} >
                                                                <label >Language</label>
                                                                <select className="input-group mb-3 form-control select2 "
                                                                    id="docLanguage" value={this.state.value}
                                                                    onChange={this.handleChangeLang}
                                                                    style={{ marginLeft: "15px", width: '75%', height: '30px', borderRadius: '4px', backgroundColor: '#F9F9FB' }}>
                                                                    {this.state.languageList.map((language) =>
                                                                        <option value={language.code}>{language.name}</option>
                                                                    )}
                                                                </select>
                                                            </div>
                                                            <div className="d-flex flex-row-reverse pt-2 col-sm-2" align="right">
                                                                <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                                                    <img src="./assets/images/refresh_white_24dp.png"></img></button>

                                                                <button className="btn action-button "
                                                                    title="Add"
                                                                    id="addMsg"
                                                                    style={{ marginRight: '-2px' }}
                                                                    onClick={this.addDocument}>
                                                                    <img src="assets/images/add_white_24dp.png" />
                                                                </button> </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-5" style={{ display: this.state.editDoc ? 'block' : 'none' }}>
                                                                <textarea
                                                                    id="editor"
                                                                    onChange={this.onEditorStateChange}
                                                                    value={this.state.editorState}
                                                                    style={{
                                                                        minHeight: '190px',
                                                                        border: "1px solid #0094c8",
                                                                        padding: '6px',
                                                                        borderRadius: '5px',
                                                                        width: "100%"
                                                                    }}
                                                                />
                                                                <div className="row">
                                                                    <div className="col-sm-12">
                                                                        <label style={{ display: this.state.docCharacterCount > 0 ? 'block' : 'none' }}>{this.state.docCharacterCount} characters of {2000}</label>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-sm-4">
                                                                        <button className="btn action-button"
                                                                            style={{ marginRight: '-2px', background: '#FF0000', display: this.state.editedId == -1 ? 'none' : 'block' }}
                                                                            onClick={() => this.setState({ hideDeletePopup: false })}>
                                                                            Delete
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-sm-8" align="right">
                                                                        <button className="btn action-button"
                                                                            style={{ marginRight: '-2px' }}
                                                                            onClick={this.state.editedId == -1 ? this.saveDocumentApi : this.updateDocumentApi}>
                                                                            Save
                                                                        </button>
                                                                        <button className="btn action-button"
                                                                            onClick={this.refreshData}>
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row col-sm-7">
                                                                <div id="doc-content" className='row'>
                                                                    {this.documentList.map((doc) => (
                                                                        <div>
                                                                            <div className='textarea' id={doc.id} style={{
                                                                                border: '1px solid #0094c8', height: '150px',
                                                                                borderRadius: '10px', width: '150px', margin: '10px', overflow: 'hidden',
                                                                                padding: '6px', background: '#ffffff'
                                                                            }} onMouseEnter={this.handleMouseEnterDoc}
                                                                                onMouseLeave={this.handleMouseLeaveDoc}>
                                                                                {doc.content}
                                                                            </div>
                                                                            <img className='img-responsive' id={doc.id + "+img"} name="image"
                                                                                src={this.editImageSrc} onClick={this.editDocument}
                                                                                onMouseEnter={this.handleMouseEnterDoc}
                                                                                style={{
                                                                                    background: "#282a65",
                                                                                    borderRadius: "5px", padding: '1px', marginTop: '-94%',
                                                                                    marginLeft: '77%', display: 'none', cursor: 'pointer',
                                                                                }}>
                                                                            </img>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className="textarea" align="left"
                                                                    style={{
                                                                        display: this.state.uploadFile ? 'block' : 'none',
                                                                        height: '170px', width: '400px',
                                                                        borderRadius: '10px', margin: '10px',
                                                                        overflow: 'hidden', padding: '6px',
                                                                    }}
                                                                >
                                                                    <div className="previewText image-container" style={{ color: "black" }}>
                                                                        *file size should be less than 2MB<br /><br />
                                                                        <b>Note</b>:Supports only .txt format</div><br />
                                                                    <div className="row"><br />
                                                                        <input type="file" accept="text/plain" id="inputFile" onChange={this.handleChangeFile}
                                                                            style={{ color: "black", paddingLeft: '10px', width: "50%" }} />
                                                                        <button className="btn action-button "
                                                                            title="Add"
                                                                            id="addMsg"
                                                                            style={{ marginLeft: '10px', marginTop: '-5px' }}
                                                                            onClick={this.saveDocumentApi}>
                                                                            Save
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-10" align='center'
                                                                style={{
                                                                    display: this.documentList.length == 0 && !this.state.addTextArea ? 'block' : 'none',
                                                                    marginTop: '20%',
                                                                    height: '200px',
                                                                    paddingLeft: '15%'
                                                                }}> <div style={{
                                                                    width: '40%',
                                                                    fontSize: '22px',
                                                                    color: '#282a65',
                                                                    marginTop: '-50px'
                                                                }}>
                                                                    No ASR Training Data added yet!
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Dialog Component For Deletion Confirmation*/}
                    <DialogComponent width='400px' animationSettings={this.settings}
                        header='ASR Training Data' showCloseIcon={true} buttons={this.buttons}
                        ref={dialog => this.dialogInstance = dialog}
                        visible={!this.state.hideDeletePopup} close={this.dialogClose}>
                        <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;Do you want to delete the training data?<br />Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/asrUi/TrainingData.js